// extracted by mini-css-extract-plugin
export default {"mealTypes":"MealTypes_mealTypes__EtLnU","checkMark":"MealTypes_checkMark__-p1aV","active":"MealTypes_active__Ts6kL"};